import { render, staticRenderFns } from "./BzSubmissionCard.vue?vue&type=template&id=fe9e1c60&scoped=true&"
import script from "./BzSubmissionCard.vue?vue&type=script&lang=js&"
export * from "./BzSubmissionCard.vue?vue&type=script&lang=js&"
import style0 from "./BzSubmissionCard.vue?vue&type=style&index=0&id=fe9e1c60&scoped=true&lang=css&"
import style1 from "./BzSubmissionCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9e1c60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAppBar,VBtn,VCard,VCardText,VContainer,VDivider,VIcon,VSheet,VSpacer,VToolbarTitle,VTooltip})
